export default __webpack_public_path__ + "static/media/Gradient_2_Dots.49be8007.svg";